export default __webpack_public_path__ + "d500606ad95318d2fa37074fc85c76eb.woff2";